import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Circles } from 'react-loader-spinner'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import { addIcon } from '../../../assests/Icons/icon'
import dollarIcon from '../../../assests/svg/dollarIcon.svg'
import { getCurrentUserData, notifyBugsnagError, setLocalUserData, setOrgLocalUserData, showToast } from '../../../common/utils/Functions'
import DashboardLayout from '../../../components/layouts/DashboardLayout'
import ConfirmationModal from '../../../components/modals/ConfirmationModal/ConfirmationModal'
import ReactLoader from '../../../components/reactLoader/ReactLoader'
import InputField from '../../../components/theme/InputField'
import ReactSelectField from '../../../components/theme/ReactSelectField'
import ThemeButton from '../../../components/theme/ThemeButton'
import AmountField from '../../../components/theme/amountField'
import useFetch from '../../../hooks/useFetch'
import { setUserData } from '../../../redux/common'
import { CustomizeSchema } from '../../../validations/ProfileSchema'
import styles from './customize.module.scss'
import TippingSettingPreviewModal from '../../../components/modals/tippingSettingPreviewModal/TippingSettingPreviewModal'

const Customize = () => {
    const { uuid } = useParams();
    const dispatch = useDispatch();
    const data = getCurrentUserData(`${uuid}`);
    const userData = getCurrentUserData(`${uuid}`);
    const stored = localStorage.getItem('properties_count');
    const hasProperties = stored == null ? true : Number(stored) > 0;

    const default_tipping_view_data = hasProperties
        ? [
            { label: 'Simple', value: 0 },
            { label: 'Select Boxes', value: 1 },
            { label: 'Disabled', value: 2 },
        ]
        : [
            { label: 'Simple', value: 0 },
            { label: 'Disabled', value: 2 },
        ]; 


    const show_notes = [
        { label: 'Yes', value: 1 },
        { label: 'No', value: 0 }
    ];
    const tipper_email_data = [
        { label: 'Yes', value: 1 },
        { label: 'No', value: 0 }
    ];
    const is_service_score = [
        { label: 'Yes', value: 1 },
        { label: 'No', value: 0 }
    ];
    const property_scoreboard_data = [
        { label: 'Private', value: 1 },
        { label: 'Public', value: 0 }
    ];
    const handleDelete = () => setOpenDelete(false);
    const [imagePreview, setImagePreview] = useState({
        url: "",
        name: "",
    });
    const [isNewImage, setIsNewImage] = useState(false);
    const [openDelete, setOpenDelete] = useState<boolean>(false); // state to handle Delete Property modal
    const [showTippingPreview, setShowTippingPreview] = useState<boolean>(false)
    const [tippingPreviewData, setTippingPreviewData] = useState<any>()


    const initialValues =
    {
        theme_color: "",
        font_color: "",
        media_id: null,
        tipping_view: null,
        is_service_score: null,
        show_notes: null,
        is_tipper_email_required: null,
        facebook_url: null,
        yelp_url: null,
        google_site_url: null,
        trip_advisor_url: null,
        suggested_amount_1: null,
        suggested_amount_2: null,
        suggested_amount_3: null,
        is_score_board: { label: 'Private', value: 1 }
    }

    /** ------ @viewprofileApi ------- */
    const [
        viewProfileApi,
        { response: viewProfile, loading: profileLoading, error: profileError },
    ] = useFetch(`/organization/view/${data?.uuid}`);

    /** ------ @updateProfileApi -------- */
    const [
        updateProfileApi,
        {
            response: updateProfile,
            loading: updateProfileLoading,
            error: updateProfileError,
        },
    ] = useFetch(
        `/organization/customize/${data?.uuid}`
        ,
        { method: "put" }
    );

    /** Api definition to get media response */
    const [mediaApi, { response, loading, error }] = useFetch(
        "/common/upload-media",
        {
            method: "post",
        },
        "formdata",
        true
    );

    // /** Api definition to delete media response */
    const [
        mediaDelApi,
        { response: delResponse, loading: delLoading },
    ] = useFetch(
        `/common/delete-media/${viewProfile?.data?.organization_media_details?.id
        }`,
        {
            method: "post",
        }
    );

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            try {
                const formdata = new FormData();
                formdata.append("files", file);
                formdata.append("type", "3");
                mediaApi(formdata);

                setImagePreview({
                    name: "",
                    url: "",
                });
                setIsNewImage(true);
            } catch (e: any) {
                notifyBugsnagError(e, {
                    api: "mediaApi",
                });
            }
        }
    };

    const handleRemoveImage = () => {
        setImagePreview({
            name: "",
            url: "",
        });
        setOpenDelete(true); // Open confirmation modal
    };

    const handleConfirmRemoveImage = () => {
        if (isNewImage) {
            // Clear the newly uploaded image state
            setImagePreview({ url: "", name: "" });
            formik.setFieldValue("media_id", null);
            setIsNewImage(false); // Reset new image flag
        } else {
            // Call API to remove the existing image
            mediaDelApi({
                type: userData?.role_id === 2 ? "1" : "2",
            });
        }
        setOpenDelete(false); // Close confirmation modal
    };

    useEffect(() => {
        if (response) {
            formik.setFieldValue("media_id", response.data[0]?.id);
            setImagePreview(response.data[0]);
        }
        if (error) {
            showToast(error.message as string, "error");
            formik.setFieldValue("media_id", null);
        }
    }, [response, error]);


    const formik = useFormik({
        initialValues,
        validationSchema:
            CustomizeSchema,
        onSubmit: (values: any) => {
            const tippingView = values?.tipping_view?.value
            const showNote = values?.show_notes?.value
            const tipperEmail = values?.is_tipper_email_required?.value
            const isServiceScore = values?.is_service_score?.value
            const isScoreboard = values?.is_score_board?.value ?? 1
            const suggestedAmount1 = values?.suggested_amount_1 || null
            const suggestedAmount2 = values?.suggested_amount_2 || null
            const suggestedAmount3 = values?.suggested_amount_3 || null
            delete values.email;

            try {
                updateProfileApi({
                    ...values,
                    country_id: values.country_id?.value,
                    tipping_view: tippingView,
                    show_notes: showNote,
                    is_tipper_email_required: tipperEmail,
                    is_service_score: isServiceScore,
                    is_score_board: isScoreboard,
                    suggested_amount_1: suggestedAmount1 || null,
                    suggested_amount_2: suggestedAmount2 || null,
                    suggested_amount_3: suggestedAmount3 || null,
                }).then((res: any) => {
                    setTippingPreviewData(res.data)
                    setShowTippingPreview(true)
                })
            } catch (e: any) {
                notifyBugsnagError(e, {
                    api: "updateProfileApi",
                });
            }
        },
    });

    /**
      * @Call all organization data  using @viewProfileApi constant
      */
    useEffect(() => {
        if (userData?.role_id === 2) {
            const timer = setTimeout(() => {
                viewProfileApi();
            }, 500);
            return () => clearTimeout(timer);
        }
    }, []);

    useEffect(() => {
        if (viewProfile) {
            setImagePreview({
                url: viewProfile?.data?.organization_media_details?.url,
                name: viewProfile?.data?.organization_media_details?.name,
            });
            setTippingPreviewData(viewProfile?.data)
        }
    }, [viewProfile]);



    useEffect(() => {
        if (updateProfile || delResponse) {
            // console.log("login as admin", updateProfile?.data?.updated_token);
            setLocalUserData(
                updateProfile?.data?.updated_token || delResponse?.data?.updated_token
            );
            showToast(updateProfile?.message as string, "success");
            if (uuid && userData?.role_id === 2) {
                setOrgLocalUserData(
                    uuid,
                    updateProfile?.data?.updated_token || delResponse?.data?.updated_token
                );
            }
            if (updateProfile) {
                viewProfileApi()
            }
            // if (updateProfile) {
            //     window.location.href = uuid ? "/" + uuid + "/dashboard" : "/";
            // }
            // dispatch(setUserData(getLocalUserData()));
            let data: any = {
                ...userData?.data,
                organization_details: { ...updateProfile?.data },
            };

            dispatch(setUserData(data));
        }
        if (updateProfileError) {
            showToast(updateProfileError.message as string, "error");
        }
    }, [updateProfile, updateProfileError, delResponse]);



    useEffect(() => {
        if (viewProfile) {
            formik.setFieldValue("theme_color", viewProfile?.data?.theme_color);
            formik.setFieldValue("font_color", viewProfile?.data?.font_color);
            formik.setFieldValue("facebook_url", viewProfile?.data?.facebook_url);
            formik.setFieldValue("yelp_url", viewProfile?.data?.yelp_url);
            formik.setFieldValue("google_site_url", viewProfile?.data?.google_site_url);
            formik.setFieldValue("trip_advisor_url", viewProfile?.data?.trip_advisor_url);
            formik.setFieldValue("suggested_amount_1", viewProfile?.data?.suggested_amount_1);
            formik.setFieldValue("suggested_amount_2", viewProfile?.data?.suggested_amount_2);
            formik.setFieldValue("suggested_amount_3", viewProfile?.data?.suggested_amount_3);
            formik.setFieldValue(
                "media_id",
                viewProfile?.data?.organization_media_details?.id
            );
            let tippingViewLabel;

            if (viewProfile?.data?.tipping_view === 0) {
                tippingViewLabel = 'Simple';
            } else if (viewProfile?.data?.tipping_view === 1) {
                tippingViewLabel = 'Select Boxes';
            } else if (viewProfile?.data?.tipping_view === 2) {
                tippingViewLabel = 'Disabled';
            }

            formik.setFieldValue("tipping_view", {
                value: viewProfile?.data?.tipping_view,
                label: tippingViewLabel
            });

            let showNoteLabel;

            if (viewProfile?.data?.show_notes === 0) {
                showNoteLabel = 'No';
            } else if (viewProfile?.data?.show_notes === 1) {
                showNoteLabel = 'Yes';
            }

            formik.setFieldValue("show_notes", {
                value: viewProfile?.data?.show_notes,
                label: showNoteLabel
            });
            let tipperEmailLabel;

            if (viewProfile?.data?.is_tipper_email_required === 0) {
                tipperEmailLabel = 'No';
            } else if (viewProfile?.data?.is_tipper_email_required === 1) {
                tipperEmailLabel = 'Yes';
            }

            formik.setFieldValue("is_tipper_email_required", {
                value: viewProfile?.data?.is_tipper_email_required,
                label: tipperEmailLabel
            });

            let isServiceScoreLabel;

            if (viewProfile?.data?.is_service_score === 0) {
                isServiceScoreLabel = 'No';
            } else if (viewProfile?.data?.is_service_score === 1) {
                isServiceScoreLabel = 'Yes';
            }

            formik.setFieldValue("is_service_score", {
                value: viewProfile?.data?.is_service_score,
                label: isServiceScoreLabel
            });

            let scoreboardLabel;
            if (viewProfile?.data?.is_score_board === 0) {
                scoreboardLabel = 'Public';
            } else if (viewProfile?.data?.is_score_board === 1) {
                scoreboardLabel = 'Private';
            }

            formik.setFieldValue("is_score_board", {
                value: viewProfile?.data?.is_score_board,
                label: scoreboardLabel
            });
        }
        if (profileError) {
            showToast(profileError.message as string, "error");
        }
    }, [viewProfile, profileError,]);

    return (
        <DashboardLayout>
            {!viewProfile && !profileError ? (
                <ReactLoader />
            ) : (
            <Container>

                <form autoComplete='off' onSubmit={formik.handleSubmit}>
                    <Row className='g-xl-4 g-3'>
                        <h4 className={styles.orgBrandSettings}>Organization Brand Settings</h4>

                        <Col xs={12}>
                            <div className={styles.orgLogoWrap}>
                                <div
                                    style={{
                                        position: "relative",
                                    }}
                                >
                                    <label
                                        style={{
                                            position: "absolute",
                                            right: 0,
                                        }}
                                        className={styles.addIcon}
                                        // onClick={handleAddIconClick}
                                        htmlFor="profileUpload"
                                    >
                                        {addIcon}
                                    </label>
                                    <div
                                        className={styles.orgLogo}
                                        style={{
                                            backgroundColor: viewProfile?.data?.theme_color,
                                        }}
                                    >
                                        <span className={styles.innerContent}>
                                            {loading ? (
                                                <Circles
                                                    height="40"
                                                    width="40"
                                                    color="#2549E8"
                                                    ariaLabel="circles-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClass=""
                                                    visible={true}
                                                />
                                            ) : imagePreview?.url ? (
                                                <img src={imagePreview?.url} alt="" />
                                            ) : (
                                                <span
                                                    style={{
                                                        position: "absolute",
                                                        top: "50px",
                                                        left: "30px",
                                                        fontSize: "12px",
                                                    }}
                                                >
                                                    No Image
                                                </span>
                                            )}
                                        </span>

                                        <input
                                            id="profileUpload"
                                            type="file"
                                            accept="image/png, image/jpeg"
                                            name="propertyLogo"
                                            className={styles.hidden}
                                            placeholder="Upload property Logo"
                                            onChange={handleFileChange}
                                        />
                                    </div>
                                </div>
                                <h3>
                                    Organization Logo
                                </h3>
                            </div>

                            {imagePreview?.url ? (
                                <ThemeButton
                                    className={styles.remove_btn}
                                    onClick={handleRemoveImage}
                                >
                                    Remove Image
                                </ThemeButton>
                            ) : null}
                        </Col>
                        <Col xxl={4} xl={4}>
                            <div className={styles.addCateg}>
                                <InputField
                                    formik={formik}
                                    name="theme_color"
                                    label="Color Theme(HEX)"
                                    placeholder="#000000"
                                    type="color"
                                />
                            </div>
                        </Col>
                        <Col xxl={4} xl={4}>
                            <div className={styles.addCateg}>
                                <InputField
                                    formik={formik}
                                    name="font_color"
                                    label="Font Color(HEX)"
                                    placeholder="#000000"
                                    type="color"
                                />
                            </div>
                        </Col>

                        <h4 className={styles.orgBrandSettings}>Rating Screen Settings</h4>
                        <Col xxl={4} xl={4}>
                            <div className={styles.addCateg}>
                                <ReactSelectField
                                    name="is_service_score"
                                    className="form_select"
                                    options={is_service_score}
                                    placeholder="Yes"
                                    label="Prompt for Service Score"
                                    formik={formik}
                                />
                            </div>
                        </Col>

                        <h4 className={styles.orgBrandSettings}>Tipping Screen Settings
                        </h4>
                        <Col xxl={4} xl={4}>
                            <div className={styles.addCateg}>
                                <ReactSelectField
                                    name="tipping_view"
                                    className="form_select"
                                    options={default_tipping_view_data}
                                    placeholder="Simple"
                                    label="Default Tipping View"
                                    formik={formik}
                                />
                            </div>
                        </Col>

                        <Col xxl={4} xl={4}>
                            <div className={styles.addCateg}>
                                <ReactSelectField
                                    name="show_notes"
                                    className="form_select"
                                    options={show_notes}
                                    placeholder="Yes"
                                    label="Show Tipping View Note"
                                    formik={formik}
                                />
                            </div>
                        </Col>

                        <Col xxl={4} xl={4}>
                            <div className={styles.addCateg}>
                                <ReactSelectField
                                    name="is_tipper_email_required"
                                    className="form_select"
                                    options={tipper_email_data}
                                    placeholder="No"
                                    label="Always Require Tipper Email Address"
                                    formik={formik}
                                />
                            </div>
                        </Col>
                        <Col xxl={4} xl={4}>
                            <AmountField
                                name="suggested_amount_1"
                                label="First Suggested Amount (Optional)"
                                formik={formik}
                                type="number"
                                icon={dollarIcon}
                                onChange={(e) =>
                                    formik.setFieldValue("suggested_amount_1", e.target.value)
                                }
                                placeholder="First Suggested Amount"
                            />
                        </Col>

                        <Col xxl={4} xl={4}>
                            <AmountField
                                name="suggested_amount_2"
                                label="Second Suggested Amount (Optional)"
                                formik={formik}
                                type="number"
                                icon={dollarIcon}
                                onChange={(e) =>
                                    formik.setFieldValue("suggested_amount_2", e.target.value)
                                }
                                placeholder="Second Suggested Amount"
                            />
                        </Col>
                        <Col xxl={4} xl={4}>
                            <AmountField
                                name="suggested_amount_3"
                                label="Third Suggested Amount (Optional)"
                                type="number"
                                formik={formik}
                                onChange={(e) =>
                                    formik.setFieldValue("suggested_amount_3", e.target.value)
                                }
                                icon={dollarIcon}
                                placeholder="Third Suggested Amount"
                            />
                        </Col>

                        <h4 className={styles.orgBrandSettings}>Thank You Screen Settings
                        </h4>
                        <Col xxl={4} xl={4}>
                            <InputField
                                formik={formik}
                                name="trip_advisor_url"
                                label="Trip Advisor URL (Optional)"
                                placeholder="Enter URL"
                            />
                        </Col>{" "}
                        <Col xxl={4} xl={4}>
                            <InputField
                                formik={formik}
                                name="google_site_url"
                                label="Google Site URL (Optional)"
                                placeholder="Enter URL"
                                onKeyDown={(e) => {
                                    if (e.key === " ") {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Col>
                        <Col xxl={4} xl={4}>
                            <InputField
                                formik={formik}
                                name="yelp_url"
                                label="Yelp URL (Optional)"
                                placeholder="Enter URL"
                                onKeyDown={(e) => {
                                    if (e.key === " ") {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Col>
                        <Col xxl={4} xl={4}>
                            <InputField
                                formik={formik}
                                name="facebook_url"
                                label="Facebook URL (Optional)"
                                placeholder="Enter URL"
                                onKeyDown={(e) => {
                                    if (e.key === " ") {
                                        e.preventDefault();
                                    }
                                }}
                            />
                        </Col>

                        <h4 className={styles.orgBrandSettings}>Scoreboard Settings</h4>
                        <Col xxl={4} xl={4}>
                            <div className={`${styles.addCateg} ${styles.scoreboardSelect}`}>
                                <ReactSelectField
                                    name="is_score_board"
                                    className="form_select"
                                    options={property_scoreboard_data}
                                    placeholder="Private"
                                    label="Property Scoreboard"
                                    formik={formik}
                                    menuPlacement="bottom"
                                    menuShouldScrollIntoView={false}
                                />
                            </div>
                        </Col>
                    </Row>
                    <Col
                        xl={12}
                        className={`${styles.formActions} text-center gap-2 d-flex justify-content-end mb-3 align-items-end`}
                    >
                        <ThemeButton type="submit" loading={updateProfileLoading}>
                            Save
                        </ThemeButton>
                        <ThemeButton
                            onClick={() => {
                                const values = formik.values as any;
                                setTippingPreviewData((prev: any) => ({
                                    ...prev,
                                    is_service_score: values?.is_service_score?.value,
                                    theme_color: values?.theme_color || prev?.theme_color,
                                    show_notes: values?.show_notes?.value ?? prev?.show_notes,
                                    tipping_view: values?.tipping_view?.value ?? prev?.tipping_view,
                                    suggested_amount_1: values?.suggested_amount_1 ?? prev?.suggested_amount_1,
                                    suggested_amount_2: values?.suggested_amount_2 ?? prev?.suggested_amount_2,
                                    suggested_amount_3: values?.suggested_amount_3 ?? prev?.suggested_amount_3,
                                }));
                                setShowTippingPreview(true);
                            }}
                        >
                            Preview
                        </ThemeButton>
                    </Col>


                    <ConfirmationModal
                        handleToggle={handleDelete}
                        title="Are you sure you want to remove this logo?"
                        show={openDelete}
                        loading={delLoading}
                        actionTitle="Remove"
                        confirm={handleConfirmRemoveImage}
                    />

                    <TippingSettingPreviewModal
                        handleToggle={() => setShowTippingPreview(false)}
                        show={showTippingPreview}
                        title=''
                        data={tippingPreviewData}
                    />
                </form>
            </Container>
            )}
        </DashboardLayout>
    )
}

export default Customize